import { Component, OnInit } from '@angular/core';
import { DataService, DateService, HTTPService, HelperService } from 'app/services';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { currency } from 'app/constants/currency.constants';
@Component({
    selector: 'app-commission-earned-dialog',
    templateUrl: './commission-earned-dialog.component.html',
    styleUrls: ['./commission-earned-dialog.component.scss'],
    providers: [DialogService],
})
export class CommissionEarnedDialogComponent implements OnInit {
  filterOptions = {
      statementBtn: false,
      date: true,
      dateRang: false,
      customerType: false,
      supplierType: false,
      itemType: false,
      tags: false,
      tech: false,
      serviceWriter: false,
  };
  totalEarning: any = [];
  earningRecords: any = [];
  pageSize: number = 10;
  startDate: any;
  endDate: any;
  usd: string = currency.USD;
  totalRecords: number = 0;
  isRequestSentAlready: boolean = false;
  loading: boolean = true;

  constructor( 
      public helperService: HelperService,
      private httpService: HTTPService,
      private dynamicDialogRef: DynamicDialogRef
      ) { }
  ngOnInit(): void {
      
  }

  filterData(event: any) {
    if(!this.isRequestSentAlready && event && event.date && event.date.startDate && event.date.endDate) {
      this.startDate = event.date.startDate;
      this.endDate = event.date.endDate;
      this.getCommissionData();
    }
  }

  getCommissionData(pageNumber: number = 1) {
    this.isRequestSentAlready = true;
    this.loading = true;
    const params = {
      page: pageNumber,
      limit: this.pageSize,
      startDate: this.startDate,
      endDate: this.endDate,
      isServiceWriter: true,
    };
        
    this.httpService.getCommissonDetails(params).then(
      (result) => {
        this.totalEarning = result.commissionResponse[0].totalSumAllDates[0];
        this.earningRecords = result.commissionResponse[0].recordsByDate;
        this.totalRecords = result.commissionResponse[0].totalRecordsByDate[0].count;
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    ).finally(() => {
      this.isRequestSentAlready = false;
      this.loading = false;
    });
  }

  paginate(event: any) {
    if(event) {
      this.getCommissionData(event.page+1);
    }
    
  }

  openRO(orderId: string){
    this.helperService.openPageInNewExistingTab(`/estimate/${orderId}`, orderId);
  }

  handleClose() {
    this.dynamicDialogRef.close();
  }
}